import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';
import App from './App';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig,fetchConfig } from './authConfig';

// Initialize a PublicClientApplication instance after fetching the configuration
const initializeMsal = async () => {
    await fetchConfig();
    const msalInstance = new PublicClientApplication(msalConfig);
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
        <React.StrictMode>
            <MsalProvider instance={msalInstance}>
                <App />
            </MsalProvider>
        </React.StrictMode>
    );
};

// Call the function to initialize MSAL after fetching the configuration
initializeMsal();

